export const MASCOT =
  'https://cdn.magicpatterns.com/patterns/generated-images/db7ecd8a-87c5-4462-a542-d874096caee9.jpg'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/rYwkXgNKYN7r3gZbNxDWmn/Banner_julio_GBP.png'

export const WHY_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/7296c609-2f4d-4ba1-8107-23d0ae78460d.jpg'

const IMG = {
  graniteBlack:
    'https://cdn.magicpatterns.com/patterns/generated-images/49b29e3e-8aa1-47e7-a23e-c4b688d97b3f.jpg',
  graniteWhite:
    'https://cdn.magicpatterns.com/patterns/generated-images/28d48e1c-3f6e-41df-9fdb-e9b099ab7ba9.jpg',
  graniteGray:
    'https://cdn.magicpatterns.com/patterns/generated-images/80740600-bd03-4f55-8721-63ea8e878acb.jpg',
  graniteBrown:
    'https://cdn.magicpatterns.com/patterns/generated-images/86c21fe8-83a2-49b5-92c6-8ee6b508c338.jpg',
  graniteGold:
    'https://cdn.magicpatterns.com/patterns/generated-images/97ec8f9e-2751-49f0-97f5-630f65bc8036.jpg',
  graniteMulti:
    'https://cdn.magicpatterns.com/patterns/generated-images/3854cc50-fdbc-414b-ae1e-f6872e395871.jpg',
  graniteKitchenBefore:
    'https://cdn.magicpatterns.com/uploads/orPS3WJDK8w2xNHwttc1sK/Granite_1.jpg',
  graniteKitchenAfter:
    'https://cdn.magicpatterns.com/uploads/inaUzbowbZAswqhjigbwu6/Granite2_Despues.jpg',
  bathBefore:
    'https://cdn.magicpatterns.com/patterns/generated-images/e5a70392-5527-4b06-b9d6-4d8cd17fdd29.jpg',
  bathAfter:
    'https://cdn.magicpatterns.com/patterns/generated-images/3df364ca-dc0f-43eb-97ca-c6c262608cc5.jpg',
  bigKitchenAfter:
    'https://cdn.magicpatterns.com/patterns/generated-images/9ce16fd8-9440-4d73-96ca-b00cee3b2dd8.jpg',
  cabinetAfter:
    'https://cdn.magicpatterns.com/patterns/generated-images/64452ef0-ce8d-4d0d-a784-2e7352f6d03e.jpg',
  roofBefore:
    'https://cdn.magicpatterns.com/patterns/generated-images/25f471ba-7e79-45e5-86b7-7a6150db7ee1.jpg',
  roofAfter:
    'https://cdn.magicpatterns.com/patterns/generated-images/7595d0d7-5dc3-484f-be5b-cc06590c11f0.jpg',
  drywallBefore:
    'https://cdn.magicpatterns.com/patterns/generated-images/72d9aaa5-7aea-4093-bcc9-bf6a7919f5ba.jpg',
  drywallAfter:
    'https://cdn.magicpatterns.com/patterns/generated-images/9e8c077d-d7e2-4e62-af86-eeae9ff7f416.jpg',
  rotBefore:
    'https://cdn.magicpatterns.com/patterns/generated-images/a6080729-445a-4d94-b4a5-195c6ed67c80.jpg',
  rotAfter:
    'https://cdn.magicpatterns.com/patterns/generated-images/3b9b882c-5b87-468b-b1ba-20bdf35562e4.jpg',
  handyBefore:
    'https://cdn.magicpatterns.com/patterns/generated-images/8bc54b93-864f-45f4-8b3e-b7c72c389949.jpg',
  handyAfter:
    'https://cdn.magicpatterns.com/patterns/generated-images/282f3f6b-822d-4d59-8490-29f95856db9b.jpg',
  paintAccentBefore:
    'https://cdn.magicpatterns.com/patterns/generated-images/3cf4477b-f146-4836-b1f4-7b77a0972b5c.jpg',
  paintAccentAfter:
    'https://cdn.magicpatterns.com/patterns/generated-images/3c5c59a4-311e-47cc-8946-6715a6ef16fe.jpg',
  paintInterior:
    'https://cdn.magicpatterns.com/patterns/generated-images/665c9ba4-8501-4a6f-a69b-b84b8a64d333.jpg',
  paintExterior:
    'https://cdn.magicpatterns.com/patterns/generated-images/32b6683b-6037-4b55-8ac7-4c9b0bcc2033.jpg',
}

export const graniteImages: Record<string, string> = {
  'absolute-noir': IMG.graniteBlack,
  'silver-cloud': IMG.graniteWhite,
  'steel-grey': IMG.graniteGray,
  'cafe-imperial': IMG.graniteBrown,
  'golden-sand': IMG.graniteGold,
  'copper-canyon': IMG.graniteMulti,
}

export const projectImages: Record<string, { before: string; after: string }> = {
  'roof-san-ysidro': { before: IMG.roofBefore, after: IMG.roofAfter },
  'granite-san-ysidro': {
    before: IMG.graniteKitchenBefore,
    after: IMG.graniteKitchenAfter,
  },
  'painting-san-ysidro': { before: IMG.paintAccentBefore, after: IMG.paintAccentAfter },
  'bathroom-san-ysidro': { before: IMG.bathBefore, after: IMG.bathAfter },
  'handyman-san-ysidro': { before: IMG.handyBefore, after: IMG.handyAfter },
}

export const portfolioImages: Record<string, string> = {
  'roof-install': IMG.roofAfter,
  'accent-wall': IMG.paintAccentAfter,
  'interior-refresh': IMG.paintInterior,
  'exterior-repaint': IMG.paintExterior,
  'fascia-renewal': IMG.rotAfter,
  'drywall-finish': IMG.drywallAfter,
  'granite-kitchen': IMG.graniteKitchenAfter,
  'absolute-noir-slab': IMG.graniteBlack,
  'copper-canyon-slab': IMG.graniteMulti,
  'spa-bathroom': IMG.bathAfter,
  'open-kitchen': IMG.bigKitchenAfter,
  'built-in-cabinetry': IMG.cabinetAfter,
}

export const portraits: Record<string, string> = {
  'maria-l':
    'https://cdn.magicpatterns.com/patterns/generated-images/22b2c623-ecee-4851-958d-78cc34e13a19.jpg',
  'carlos-r':
    'https://cdn.magicpatterns.com/patterns/generated-images/4e547b09-bfb9-4876-8e15-9d59d450f6d0.jpg',
  'david-h':
    'https://cdn.magicpatterns.com/patterns/generated-images/08678a81-e98a-4454-b92c-9da883eafd14.jpg',
  'james-m':
    'https://cdn.magicpatterns.com/patterns/generated-images/17d430a0-9a03-4be6-8dcb-51a3b046c8f1.jpg',
}

export const CONTACT = {
  phoneDisplay: '(805) 310-6530',
  phoneRaw: '8053106530',
  whatsapp: '18053106530',
  email: 'Pollo6730@gmail.com',
  license: 'Lic. 1126459',
  company: 'Pollo Construction & Granite Inc.',
  tagline: 'Make Your Home Reality',
}
